import { render, staticRenderFns } from "./ItemTypeList.vue?vue&type=template&id=4fecb771"
import script from "./ItemTypeList.vue?vue&type=script&lang=js"
export * from "./ItemTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports